/**
 * Masterclass entry point
 */
import _d from '@repperjs/debug';
import { createRoot } from 'react-dom/client';
import React from 'react';
import Login from './components/masterclass/Login/Login.tsx';
import { startOpenPanel } from '@repperjs/shared/src/services/openpanel/startOpenPanel.ts';

const log = _d('repper::masterclass'),
    error = _d('repper:error'),
    warn = _d('repper:warning');

async function run() {
    startOpenPanel();

    // ========================================================
    // Render Setup
    // ========================================================
    const MOUNT_NODE = document.getElementById('root');
    if (!MOUNT_NODE) {
        throw new Error('Mount node not found');
    }

    const render = () => {
        const root = createRoot(MOUNT_NODE);
        root.render(<Login />);
    };

    // ========================================================
    // Go!
    // ========================================================

    render();
}

run();
